(function () {
    /* Theme editor: selecting a review block jumps to its page and shows it */
    if (!window.__aev3Editor) {
      window.__aev3Editor = true;
      document.addEventListener('shopify:block:select', function (e) {
        var card = e.target && e.target.closest ? e.target.closest('.aev3__card') : null;
        if (!card) return;
        var root = card.closest('aev-reviews');
        if (root && root._aev3Show) root._aev3Show(card);
      });
      document.addEventListener('shopify:block:select', function (e) {
        var d = e.target && e.target.classList && e.target.classList.contains('aevrg-f') ? e.target : null;
        if (d && !d.open && typeof d.showModal === 'function') d.showModal();
      });
      document.addEventListener('shopify:block:deselect', function (e) {
        var d = e.target && e.target.classList && e.target.classList.contains('aevrg-f') ? e.target : null;
        if (d && d.open) d.close();
      });
    }
    if (!window.customElements || customElements.get('aev-reviews')) return;

    function daysAgo(txt) {
      var low = String(txt || '').toLowerCase();
      if (/today|just now/.test(low)) return 0;
      var m = low.match(/(\d+|an?|one)\s*(minute|hour|day|week|month|year)/);
      if (!m) return Infinity;
      var n = /^\d+$/.test(m[1]) ? parseInt(m[1], 10) : 1;
      var mult = { minute: 1 / 1440, hour: 1 / 24, day: 1, week: 7, month: 30, year: 365 }[m[2]];
      return n * mult;
    }

    customElements.define('aev-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var root = this;
        var list = root.querySelector('[data-list]');
        var pagesEl = root.querySelector('[data-pages]');
        var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 15;
        var cards = list ? Array.prototype.slice.call(list.querySelectorAll('.aev3__card')) : [];
        var state = { sort: 'relevant', filter: 0, page: 1 };

        function ordered() {
          var arr = cards.slice();
          if (state.filter) arr = arr.filter(function (c) { return +c.getAttribute('data-rating') === state.filter; });
          var idx = function (c) { return +c.getAttribute('data-i'); };
          var cmp = {
            relevant: function (a, b) { return idx(a) - idx(b); },
            photo: function (a, b) { return (+b.getAttribute('data-photo') - +a.getAttribute('data-photo')) || idx(a) - idx(b); },
            newest: function (a, b) { return (daysAgo(a.getAttribute('data-date')) - daysAgo(b.getAttribute('data-date'))) || idx(a) - idx(b); },
            highest: function (a, b) { return (+b.getAttribute('data-rating') - +a.getAttribute('data-rating')) || idx(a) - idx(b); },
            lowest: function (a, b) { return (+a.getAttribute('data-rating') - +b.getAttribute('data-rating')) || idx(a) - idx(b); }
          }[state.sort];
          return arr.sort(function (a, b) { var d = cmp(a, b); return isNaN(d) ? idx(a) - idx(b) : d; });
        }

        function colCount() {
          var st = getComputedStyle(root);
          var w = window.innerWidth;
          var d = parseInt(st.getPropertyValue('--a3-cols'), 10) || 5;
          var m = parseInt(st.getPropertyValue('--a3-cols-m'), 10) || 2;
          if (w <= 767) return m;
          if (w <= 1099) return Math.min(3, d);
          return d;
        }

        /* Cards that are not on the current page live in a stash outside the grid,
           hidden with an inline style, so no theme CSS can pull them into the layout. */
        var stash = document.createElement('div');
        stash.className = 'aev3__stash';
        stash.setAttribute('aria-hidden', 'true');
        stash.style.setProperty('display', 'none', 'important');
        if (list) list.parentNode.insertBefore(stash, list.nextSibling);

        function layout(visible) {
          if (!list) return;
          list.querySelectorAll('.aev3__col').forEach(function (c) { c.remove(); });
          cards.forEach(function (c) { c.hidden = true; stash.appendChild(c); });
          var n = Math.max(1, Math.min(colCount(), visible.length || 1));
          list.classList.add('is-masonry');
          var cols = [];
          for (var i = 0; i < n; i++) { var col = document.createElement('div'); col.className = 'aev3__col'; list.appendChild(col); cols.push(col); }
          visible.forEach(function (card) {
            card.hidden = false;
            var t = cols[0];
            for (var j = 1; j < cols.length; j++) if (cols[j].offsetHeight < t.offsetHeight - 1) t = cols[j];
            t.appendChild(card);
          });
        }

        function renderPages(total) {
          if (!pagesEl) return;
          var pages = Math.max(1, Math.ceil(total / perPage));
          pagesEl.hidden = pages <= 1;
          var holder = pagesEl.querySelector('[data-page-items]');
          var prevBtn = pagesEl.querySelector('[data-page-prev]');
          var nextBtn = pagesEl.querySelector('[data-page-next]');
          if (!holder || !prevBtn || !nextBtn) return;
          while (holder.firstChild) holder.removeChild(holder.firstChild);
          for (var p = 1; p <= pages; p++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'aev3__pitem' + (p === state.page ? ' is-active' : '');
            b.textContent = String(p);
            b.setAttribute('data-page', String(p));
            if (p === state.page) b.setAttribute('aria-current', 'page');
            holder.appendChild(b);
          }
          prevBtn.hidden = state.page <= 1;
          nextBtn.hidden = state.page >= pages;
        }

        function apply(scroll) {
          root.classList.add('is-ready');
          var all = ordered();
          var pages = Math.max(1, Math.ceil(all.length / perPage));
          if (state.page > pages) state.page = pages;
          var start = (state.page - 1) * perPage;
          layout(all.slice(start, start + perPage));
          renderPages(all.length);
          root.classList.add('is-ready');
          if (scroll) {
            var top = root.getBoundingClientRect().top;
            if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }

        root._aev3Show = function (card) {
          state.filter = 0;
          root.classList.remove('is-filtering');
          root.querySelectorAll('.aev3__bar').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
          var pos = ordered().indexOf(card);
          if (pos < 0) { state.sort = 'relevant'; pos = ordered().indexOf(card); }
          state.page = Math.floor(Math.max(0, pos) / perPage) + 1;
          apply(false);
          card.scrollIntoView({ block: 'center', behavior: 'smooth' });
        };

        /* ---------- review detail popup ---------- */
        var detail = root.querySelector('.aev3__detail');
        var dbox = detail ? detail.querySelector('.aev3__dbox') : null;
        var dImg = detail ? detail.querySelector('[data-dimg]') : null;
        var gallery = [], gi = 0;
        var safeUrl = function (u) { return /^(https?:\/\/|\/)/i.test(u); };
        function textOf(p) {
          var out = '';
          (function walk(n) {
            n.childNodes.forEach(function (c) {
              if (c.nodeType === 3) out += c.nodeValue;
              else if (c.nodeName === 'BR') out += '\n';
              else if (c.nodeType === 1 && !c.hasAttribute('data-more')) walk(c);
            });
          })(p);
          return out.replace(/\n{3,}/g, '\n\n').trim();
        }
        function showPhoto() {
          if (!dImg) return;
          if (gallery.length) dImg.src = gallery[gi];
          detail.querySelector('[data-dprev]').hidden = gallery.length < 2;
          detail.querySelector('[data-dnext]').hidden = gallery.length < 2;
          detail.querySelectorAll('.aev3__dthumb').forEach(function (t, i) { t.classList.toggle('is-active', i === gi); });
        }
        function openDetail(card, start) {
          if (!detail || typeof detail.showModal !== 'function' || !card) return;
          var ph = card.querySelector('[data-photos]');
          gallery = ph ? ph.getAttribute('data-photos').split('|').filter(function (u) { return u && safeUrl(u); }) : [];
          gi = Math.min(start || 0, Math.max(0, gallery.length - 1));
          dbox.classList.toggle('no-media', !gallery.length);
          var nameEl = card.querySelector('.aev3__name');
          detail.querySelector('[data-dname]').textContent = nameEl ? nameEl.textContent.trim() : '';
          detail.querySelector('[data-dver]').hidden = !card.querySelector('.aev3__ver');
          var ds = detail.querySelector('[data-dstars]');
          while (ds.firstChild) ds.removeChild(ds.firstChild);
          var cs = card.querySelector('.aev3__stars');
          if (cs) Array.prototype.forEach.call(cs.children, function (c) { ds.appendChild(c.cloneNode(true)); });
          var dateEl = card.querySelector('.aev3__date');
          detail.querySelector('[data-ddate]').textContent = dateEl ? dateEl.textContent.trim() : '';
          var tp = card.querySelector('.aev3__text');
          detail.querySelector('[data-dtext]').textContent = tp ? textOf(tp) : '';
          var th = detail.querySelector('[data-dthumbs]');
          while (th.firstChild) th.removeChild(th.firstChild);
          if (gallery.length > 1) {
            gallery.forEach(function (u, i) {
              var b = document.createElement('button');
              b.type = 'button'; b.className = 'aev3__dthumb'; b.setAttribute('data-dthumb', String(i));
              var im = document.createElement('img'); im.src = u; im.alt = ''; im.loading = 'lazy';
              b.appendChild(im); th.appendChild(b);
            });
          }
          showPhoto();
          detail.showModal();
          var info = detail.querySelector('.aev3__dinfo'); if (info) info.scrollTop = 0;
        }

        /* ---------- write-a-review form ---------- */
        var fdialog = root.querySelector('.aevrg-f');
        var fform = fdialog ? fdialog.querySelector('form') : null;
        function validate() {
          if (!fform) return;
          var btn = fform.querySelector('[data-review-submit]');
          if (!btn) return;
          var rated = !!fform.querySelector('input[name="contact[Rating]"]:checked');
          var text = fform.querySelector('[data-review-text]');
          var name = fform.querySelector('input[name="contact[name]"]');
          var email = fform.querySelector('input[name="contact[email]"]');
          btn.disabled = !(rated && text && text.value.trim() && name && name.value.trim() && email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()));
        }
        if (fform) {
          fform.addEventListener('input', function (e) {
            if (e.target.matches('[data-review-text]')) {
              var c = fform.querySelector('[data-review-count]');
              if (c) c.textContent = e.target.value.length + '/2000';
            }
            validate();
          });
          fform.addEventListener('change', validate);
          fform.addEventListener('submit', function (e) {
            validate();
            var b = fform.querySelector('[data-review-submit]');
            if (b && b.disabled) e.preventDefault();
          });
          validate();
        }
        if (fdialog && root.querySelector('[data-form-result]') && typeof fdialog.showModal === 'function') fdialog.showModal();

        /* ---------- sort popup ---------- */
        var popup = root.querySelector('[data-sort-popup]');
        var toggle = root.querySelector('[data-sort-toggle]');
        function closeSort() { if (popup) { popup.hidden = true; toggle && toggle.setAttribute('aria-expanded', 'false'); } }
        document.addEventListener('click', function (e) { if (popup && !popup.hidden && !e.target.closest('.aev3__sort')) closeSort(); });

        function activate(el) {
          if (el.matches('[data-more]')) {
            var rest = el.nextElementSibling;
            if (rest) rest.hidden = false;
            el.remove();
            requestAnimationFrame(function () { apply(false); });
            return true;
          }
          if (el.matches('.aev3__sitem')) {
            state.sort = el.getAttribute('data-sort');
            state.page = 1;
            root.querySelectorAll('.aev3__sitem').forEach(function (s) { var on = s === el; s.classList.toggle('is-active', on); s.setAttribute('aria-selected', on ? 'true' : 'false'); });
            closeSort(); apply(true);
            return true;
          }
          if (el.matches('.aev3__bar')) {
            var f = +el.getAttribute('data-filter');
            state.filter = state.filter === f ? 0 : f;
            state.page = 1;
            root.classList.toggle('is-filtering', !!state.filter);
            root.querySelectorAll('.aev3__bar').forEach(function (b) { var on = +b.getAttribute('data-filter') === state.filter; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
            apply(true);
            return true;
          }
          return false;
        }

        root.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-more], .aev3__sitem, .aev3__bar')) { e.preventDefault(); activate(e.target); }
        });

        root.addEventListener('click', function (e) {
          var t = e.target;
          if (t.closest('[data-open-review]') && fdialog && typeof fdialog.showModal === 'function') { fdialog.showModal(); return; }
          if (fdialog && (t === fdialog || t.closest('[data-close-form]'))) { fdialog.close(); return; }
          var pt = t.closest('[data-photo-toggle]');
          if (pt) {
            var note = pt.parentElement.querySelector('[data-photo-note]');
            if (note) { note.hidden = !note.hidden; pt.setAttribute('aria-expanded', note.hidden ? 'false' : 'true'); }
            return;
          }
          if (t.closest('[data-sort-toggle]')) {
            popup.hidden = !popup.hidden;
            toggle.setAttribute('aria-expanded', popup.hidden ? 'false' : 'true');
            return;
          }
          var act = t.closest('[data-more], .aev3__sitem, .aev3__bar');
          if (act && root.contains(act) && activate(act)) return;
          var pg = t.closest('[data-page]');
          if (pg) { state.page = +pg.getAttribute('data-page'); apply(true); return; }
          if (t.closest('[data-page-prev]')) { state.page = Math.max(1, state.page - 1); apply(true); return; }
          if (t.closest('[data-page-next]')) { state.page += 1; apply(true); return; }
          if (detail && detail.contains(t)) {
            if (t.closest('[data-dprev]')) { gi = (gi - 1 + gallery.length) % gallery.length; showPhoto(); return; }
            if (t.closest('[data-dnext]')) { gi = (gi + 1) % gallery.length; showPhoto(); return; }
            var dt = t.closest('[data-dthumb]');
            if (dt) { gi = +dt.getAttribute('data-dthumb'); showPhoto(); return; }
            if (t === detail || t.closest('[data-detail-close]')) { detail.close(); return; }
            return;
          }
          var th = t.closest('[data-open-review-photos]');
          if (th) {
            openDetail(root.querySelector('.aev3__card[data-block="' + th.getAttribute('data-open-review-photos') + '"]'), 0);
            return;
          }
          var cardEl = t.closest('.aev3__card');
          if (cardEl && root.contains(cardEl)) { openDetail(cardEl, 0); return; }
        });

        apply(false);
        list && list.querySelectorAll('img').forEach(function (img) {
          if (!img.complete) img.addEventListener('load', function () { apply(false); }, { once: true });
        });
        var tm, lastCols = colCount();
        window.addEventListener('resize', function () {
          clearTimeout(tm);
          tm = setTimeout(function () { var c = colCount(); if (c !== lastCols) { lastCols = c; apply(false); } }, 150);
        });
      }
    });
  })();
